import React from 'react';
import RptDetlBgt from './RptDetailedBgt';
import '../../../CommonCSS/SocietyCSS.css'

const RptDtlBgtApp = () => {
  return (

    <div className="app-wrapper">
      <div className="form-container">
        <div className='card' style={{borderRadius: '8px'}}>
          <div className="card-header-css" style={{borderRadius: '8px', textAlign: 'center' }} >
            <h5>Detailed Budget Report</h5>
          </div>
        </div>
        <RptDetlBgt />
      </div>
    </div >
  );
};

export default RptDtlBgtApp;
